/* ==========================================================================
   Price mode — bascule « Comptant / 3x / 4x / 10x / 12x » des product cards
   des collections.
   Le mode est porté par l'attribut data-price-mode du conteneur parent
   (rendu côté serveur : 12x sur les collections location, comptant ailleurs) ; le CSS (product-grid.css) affiche
   la mensualité Alma correspondante (snippets/alma-monthly-price.liquid).
   Le choix du visiteur est mémorisé (localStorage: loewi_price_mode) et
   réappliqué à chaque re-render AJAX des filtres (connectedCallback).
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'loewi_price_mode';
  var MODES = ['cash', '3', '4', '10', '12'];

  function getStoredMode() {
    try {
      var mode = localStorage.getItem(KEY);
      return MODES.indexOf(mode) > -1 ? mode : null;
    } catch (e) {
      return null;
    }
  }

  function storeMode(mode) {
    try {
      localStorage.setItem(KEY, mode);
    } catch (e) {
      /* stockage indisponible : le choix vaut pour la page courante */
    }
  }

  class LoewiPriceMode extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.sync = this.sync.bind(this);
    }

    connectedCallback() {
      this.scope = this.closest('[data-price-mode]');
      if (!this.scope) return;

      var stored = getStoredMode();
      if (stored) this.scope.setAttribute('data-price-mode', stored);

      this.sync();
      this.addEventListener('click', this.onClick);
      document.addEventListener('loewi:price-mode-change', this.sync);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('loewi:price-mode-change', this.sync);
    }

    onClick(event) {
      var button = event.target.closest('[data-mode]');
      if (!button || !this.scope) return;

      var mode = button.getAttribute('data-mode');
      this.scope.setAttribute('data-price-mode', mode);
      storeMode(mode);

      document.dispatchEvent(new CustomEvent('loewi:price-mode-change', { detail: { mode: mode } }));
    }

    // Met à jour aria-pressed ; appelé aussi quand l'autre bascule de la page change le mode
    sync() {
      if (!this.scope) return;
      var mode = this.scope.getAttribute('data-price-mode');
      this.querySelectorAll('[data-mode]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-mode') === mode));
      });
    }
  }

  if (!customElements.get('loewi-price-mode')) {
    customElements.define('loewi-price-mode', LoewiPriceMode);
  }
})();
